import { TextField } from '@material-ui/core';
import usePmTagsFetchStrategySetting from './usePmTagsFetchStrategySetting';
import { useState } from 'react';
import SettingWrapper from '../view/SettingWrapper';

const PmIssueTagsFetchStrategy = () => {
  const {
    defaultPattern = '',
    customPattern = '',
    onSave,
    onDelete
  } = usePmTagsFetchStrategySetting();
  const [pattern, setPattern] = useState(customPattern);

  const title = 'Correlate issues with Git repositories'.toUpperCase();
  const description = (
    <>
      Specify a regular expression that LinearB will search in PR title, branch
      title or Commit message. LinearB will use this to associate between Git
      work and issues. Note: if no regular expression is specified, LinearB will
      search by a default regular expression. <br />
      The default expression patterns we are using for extracting issues keys
      are:
      <div className='whitespace-pre text-sm'>
        {Array.isArray(defaultPattern) ? defaultPattern.join('   |   ') : 'N/A'}
      </div>
    </>
  );

  const hasPatternChanged = customPattern !== pattern;

  const restoreToDefault = async () => {
    await onDelete();
    setPattern('');
  };

  return (
    <SettingWrapper
      title={title}
      description={description}
      onSave={() => onSave(pattern)}
      onRestore={restoreToDefault}
      isSaveDisabled={!(pattern.length > 0 && hasPatternChanged)}
      isRestoreDisabled={!customPattern && !hasPatternChanged}
    >
      <TextField
        inputProps={{ style: { fontSize: 15 } }}
        variant='outlined'
        onChange={e => setPattern(e.target.value)}
        value={pattern}
        placeholder='Set custom Regex'
      />
    </SettingWrapper>
  );
};
export default PmIssueTagsFetchStrategy;
